export const interestsPath = 'interests'
